import { FC, useMemo } from "react";
import useEvent from "react-use-event-hook";
import { useRecoilState } from "recoil";

import { SVG_MUI } from "@ryde/assets";
import { CheckboxControlledMui } from "@ryde/controls";
import { useMapColors, usePageContext } from "@ryde/redux";
import { isSelectedIdSF } from "@ryde/shared";
import { blueGreyMui } from "@ryde/theme";

import { IRidesKanbanDragOrSelectHandle } from "./rides.kanban.drag-or-select-handle.models";

export const RidesKanbanDragOrSelectHandleClone: FC<
  IRidesKanbanDragOrSelectHandle
> = ({ rideDto }) => {
  const { entity } = usePageContext();
  const [isSelected] = useRecoilState(isSelectedIdSF([entity, rideDto.id]));
  const { getMapColorByRideId } = useMapColors();

  const gripColor = useMemo(() => {
    return isSelected ? getMapColorByRideId(rideDto.id) : blueGreyMui._200;
  }, [rideDto.id, getMapColorByRideId, isSelected]);

  const handleSelectToggleNoop = useEvent((): void => {});

  return (
    <>
      <button className="dragButton">
        <SVG_MUI.GripVerticalColoredSVG
          className="pointer"
          fill={gripColor}
          data-e2e="drag-grip-vertical"
        />
      </button>
      <CheckboxControlledMui
        width={15}
        height={15}
        checked={isSelected}
        setCheckedToggle={handleSelectToggleNoop}
        e2eData="kanban-item-selected-checkbox"
      />
    </>
  );
};
